/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as import0 from '@angular/core';
import * as import1 from '../../page-layout/modal-page-layout/modal-page-layout.component.ngfactory';
import * as import2 from '../../page-layout/modal-page-layout/modal-page-layout.component';
import * as import3 from '../../orchestration/page';
import * as import4 from '../../orchestration/navigation.service';
import * as import5 from '@angular/common';
import * as import6 from './legal-page.component';
import * as import7 from '../../orchestration/navigation-params';
const styles_LegalPageComponent:any[] = ([] as any[]);
export const RenderType_LegalPageComponent:import0.RendererType2 = import0.ɵcrt({
  encapsulation: 2,
  styles: styles_LegalPageComponent,
  data: {}
}
);
function View_LegalPageComponent_1(l:any):import0.ɵViewDefinition {
    return import0.ɵvid(0,[(l()(),import0.ɵeld(0,(null as any),(null as any),0,'iframe',[
      [
        'class',
        'legal-content'
      ]
      ,
      [
        'src',
        'https://chewzie.me/chewzie_terms/'
      ]

    ]
  ,(null as any),(null as any),(null as any),(null as any),(null as any)))],(null as any),(null as any));
}
function View_LegalPageComponent_2(l:any):import0.ɵViewDefinition {
    return import0.ɵvid(0,[(l()(),import0.ɵeld(0,(null as any),(null as any),0,'iframe',[
      [
        'class',
        'legal-content'
      ]
      ,
      [
        'src',
        'https://chewzie.me/chewzie_privacy_policy/'
      ]

    ]
  ,(null as any),(null as any),(null as any),(null as any),(null as any)))],(null as any),(null as any));
}
export function View_LegalPageComponent_0(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    import0.ɵqud(402653184,1,{pageLayout: 0}),
    (l()(),import0.ɵeld(0,(null as any),(null as any),12,'woa-modal-page-layout',([] as any[]),(null as any),(null as any),(null as any),import1.View_ModalPageLayoutComponent_0,import1.RenderType_ModalPageLayoutComponent)),
    import0.ɵdid(114688,(null as any),2,import2.ModalPageLayoutComponent,[
      import3.Page,
      import4.NavigationService
    ]
      ,{customGeometry: [
        0,
        'customGeometry'
      ]
    },(null as any)),
    import0.ɵqud(603979776,2,{contentMessages: 1}),
    import0.ɵqud(603979776,3,{footerControls: 1}),
    import0.ɵpod(['pillarboxedOnDesktop']),
      import0.ɵprd(2048,[[
        1,
        4
      ]
    ],import3.PageLayout,(null as any),[import2.ModalPageLayoutComponent]),
    (l()(),import0.ɵted(4,['\n    '])),
    (l()(),import0.ɵand(16777216,(null as any),4,1,(null as any),View_LegalPageComponent_1)),
    import0.ɵdid(16384,(null as any),0,import5.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted(4,['\n    '])),
    (l()(),import0.ɵand(16777216,(null as any),4,1,(null as any),View_LegalPageComponent_2)),
    import0.ɵdid(16384,(null as any),0,import5.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted(4,['\n'])),
    (l()(),import0.ɵted((null as any),['\n']))
  ]
  ,(ck,v) => {
    var co:import6.LegalPageComponent = v.component;
    const currVal_0:any = ck(v,5,0,'none');
    ck(v,2,0,currVal_0);
    const currVal_1:any = (co.display == 'terms');
    ck(v,9,0,currVal_1);
    const currVal_2:any = (co.display == 'privacy');
    ck(v,12,0,currVal_2);
  },(null as any));
}
function View_LegalPageComponent_Host_0(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),2,'woa-legal-page',([] as any[]),(null as any),(null as any),(null as any),View_LegalPageComponent_0,RenderType_LegalPageComponent)),
    import0.ɵdid(49152,(null as any),0,import6.LegalPageComponent,[import7.NavigationParams],(null as any),(null as any)),
    import0.ɵprd(6144,(null as any),import3.Page,(null as any),[import6.LegalPageComponent])
  ]
  ,(null as any),(null as any));
}
export const LegalPageComponentNgFactory:import0.ComponentFactory<import6.LegalPageComponent> = import0.ɵccf('woa-legal-page',import6.LegalPageComponent,View_LegalPageComponent_Host_0,{},{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL2hvbWUvcnVubmVyL3dvcmsvd2ViLW9yZGVyaW5nLWFwcC93ZWItb3JkZXJpbmctYXBwL3NyYy9hcHAvbGVnYWwvbGVnYWwtcGFnZS9sZWdhbC1wYWdlLmNvbXBvbmVudC5uZ2ZhY3RvcnkudHMiLCJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJuZzovLy9ob21lL3J1bm5lci93b3JrL3dlYi1vcmRlcmluZy1hcHAvd2ViLW9yZGVyaW5nLWFwcC9zcmMvYXBwL2xlZ2FsL2xlZ2FsLXBhZ2UvbGVnYWwtcGFnZS5jb21wb25lbnQudHMiLCJuZzovLy9ob21lL3J1bm5lci93b3JrL3dlYi1vcmRlcmluZy1hcHAvd2ViLW9yZGVyaW5nLWFwcC9zcmMvYXBwL2xlZ2FsL2xlZ2FsLXBhZ2UvbGVnYWwtcGFnZS5jb21wb25lbnQuaHRtbCIsIm5nOi8vL2hvbWUvcnVubmVyL3dvcmsvd2ViLW9yZGVyaW5nLWFwcC93ZWItb3JkZXJpbmctYXBwL3NyYy9hcHAvbGVnYWwvbGVnYWwtcGFnZS9sZWdhbC1wYWdlLmNvbXBvbmVudC50cy5MZWdhbFBhZ2VDb21wb25lbnRfSG9zdC5odG1sIl0sInNvdXJjZXNDb250ZW50IjpbIiAiLCI8d29hLW1vZGFsLXBhZ2UtbGF5b3V0IFtjdXN0b21HZW9tZXRyeV09XCJ7cGlsbGFyYm94ZWRPbkRlc2t0b3A6ICdub25lJ31cIj5cbiAgICA8aWZyYW1lICpuZ0lmPVwiZGlzcGxheSA9PSAndGVybXMnXCIgc3JjPVwiaHR0cHM6Ly9jaGV3emllLm1lL2NoZXd6aWVfdGVybXMvXCIgY2xhc3M9XCJsZWdhbC1jb250ZW50XCI+PC9pZnJhbWU+XG4gICAgPGlmcmFtZSAqbmdJZj1cImRpc3BsYXkgPT0gJ3ByaXZhY3knXCIgc3JjPVwiaHR0cHM6Ly9jaGV3emllLm1lL2NoZXd6aWVfcHJpdmFjeV9wb2xpY3kvXCIgY2xhc3M9XCJsZWdhbC1jb250ZW50XCI+PC9pZnJhbWU+XG48L3dvYS1tb2RhbC1wYWdlLWxheW91dD5cbiIsIjx3b2EtbGVnYWwtcGFnZT48L3dvYS1sZWdhbC1wYWdlPiJdLCJtYXBwaW5ncyI6IkFBQUE7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7OzsyQkNDSTtNQUFBO1FBQUE7UUFBQTtNQUFBOztNQUFBO1FBQUE7UUFBQTtNQUFBOztJQUFBO0dBQUE7OzsyQkFDQTtNQUFBO1FBQUE7UUFBQTtNQUFBOztNQUFBO1FBQUE7UUFBQTtNQUFBOztJQUFBO0dBQUE7Ozs7O0lBRko7Z0JBQUE7OztJQUFBO09BQUE7UUFBQTtRQUFBO01BQUE7SUFBQTtnQkFBQTtnQkFBQTtnQkFBdUI7a0JBQXZCO1FBQUE7UUFBQTtNQUFBO0lBQUE7SUFBeUU7SUFDckU7Z0JBQUE7OztJQUFBO09BQUE7UUFBQTtRQUFBO01BQUE7SUFBQTtJQUEwRztJQUMxRztnQkFBQTs7O0lBQUE7T0FBQTtRQUFBO1FBQUE7TUFBQTtJQUFBO0lBQXFIO0lBQ2pHOzs7O0lBSEQ7SUFBdkIsU0FBdUIsU0FBdkI7SUFDWTtJQUFSLFNBQVEsU0FBUjtJQUNRO0lBQVIsVUFBUSxTQUFSOzs7OztJQ0ZKO2dCQUFBO2dCQUFBOzs7OyJ9



// WEBPACK FOOTER //
// ./src/app/legal/legal-page/legal-page.component.ngfactory.ts